export default "__VITE_ASSET__2X9RIBNDO30ulRXxNCcA3w__"